export default [
  {
    name: "ViNewsList",
    path: "/vi/news-list",
    component: () => import('@/views/viPortal/news-list.vue'),
    meta: {
      title: 'VI新闻'
    },
  },
  {
    name: 'ViAddNews',
    path: '/vi/add-news',
    component: () => import('@/views/viPortal/components/new-form.vue'),
    meta: {
      parentAuth: '/vi/news-list',
      title: '新增新闻',
    },
    props: () => ({
      type: 'add'
    })
  },
  {
    name: 'ViEditNews',
    path: '/vi/edit-news/:id',
    component: () => import('@/views/viPortal/components/new-form.vue'),
    meta: {
      parentAuth: '/vi/news-list',
      title: '编辑新闻',
    },
    props: route => ({
      ...route.params,
      type: 'edit'
    })
  },
  {
    name: 'ViViewNews',
    path: '/vi/view-news/:id',
    component: () => import('@/views/viPortal/components/new-form.vue'),
    meta: {
      parentAuth: '/vi/news-list',
      title: '查看新闻',
    },
    props: route => ({
      ...route.params,
      type: 'view'
    })
  },
  {
    name: "ViVisualInfoList",
    path: "/vi/visual-info-list",
    component: () => import('@/views/viPortal/visual-info-list.vue'),
    meta: {
      title: 'VI视觉资料库'
    },
  },
  {
    name: 'ViAddVisualInfo',
    path: '/vi/add-visual-info',
    component: () => import('@/views/viPortal/components/visual-info-form.vue'),
    meta: {
      parentAuth: '/vi/visual-info-list',
      title: '新增视觉资料',
    },
    props: () => ({
      type: 'add'
    })
  },
  {
    name: 'ViEditVisualInfo',
    path: '/vi/edit-visual-info/:id',
    component: () => import('@/views/viPortal/components/visual-info-form.vue'),
    meta: {
      parentAuth: '/vi/visual-info-list',
      title: '编辑视觉资料',
    },
    props: route => ({
      ...route.params,
      type: 'edit'
    })
  },
  {
    name: 'ViViewVisualInfo',
    path: '/vi/view-visual-info/:id',
    component: () => import('@/views/viPortal/components/visual-info-form.vue'),
    meta: {
      parentAuth: '/vi/visual-info-list',
      title: '查看视觉资料',
    },
    props: route => ({
      ...route.params,
      type: 'view'
    })
  },
  {
    name: "ViAdviceList",
    path: "/vi/advice-list",
    component: () => import('@/views/viPortal/advice-list.vue'),
    meta: {
      title: '建议收集'
    },
  },
  {
    name: "ViCoverageList",
    path: "/vi/coverage-list",
    component: () => import('@/views/viPortal/coverage-list.vue'),
    meta: {
      title: 'VI覆盖率'
    },
  },
  {
    name: "ViReportList",
    path: "/vi/report-list",
    component: () => import('@/views/viPortal/report-list.vue'),
    meta: {
      title: 'VI规范报告'
    },
  },
  {
    name: "ViSupervisorList",
    path: "/vi/supervisor-list",
    component: () => import('@/views/viPortal/supervisor-list.vue'),
    meta: {
      title: 'VI监管会成员'
    },
  },
  {
    name: 'ViBannerManageList',
    path: '/vi/bannerManage/list',
    component: () => import('@/views/viPortal/banner_manage/list.vue'),
    meta: {
      title: 'banner管理'
    }
  },
];
